<template>
  <transition :name="transitionName">
    <div
      v-show="visible"
      :title="title"
      class="back-to-top"
      @click="backToTop"
    >
      <i class="go-back-icon"></i>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'BackToTop',

  props: {
    title: {
      type: String,
      default: undefined
    },
    selector: {
      type: String,
      default: 'html'
    },
    showOnScrollTop: {
      type: Number,
      default: 400
    },
    backPosition: {
      type: Number,
      default: 0
    },
    transitionName: {
      type: String,
      default: 'back2top'
    }
  },

  data() {
    return {
      visible: false,
      interval: null,
      node: null
    };
  },

  mounted() {
    this.node = window.document.querySelector(this.selector);
    window.addEventListener('scroll', this.handleScroll);
  },

  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);

    if (this.interval) {
      clearInterval(this.interval);
    }
  },

  methods: {
    handleScroll() {
      this.visible = this.node.scrollTop > this.showOnScrollTop;
    },

    backToTop() {
      const start = this.node.scrollTop;
      let i = 0;

      this.interval = setInterval(() => {
        const next = Math.floor(this.easeInOutQuad(10 * i, start, -start, 500));
        if (next <= this.backPosition) {
          this.node.scrollTo(0, this.backPosition);
          clearInterval(this.interval);
        } else {
          this.node.scrollTo(0, next);
        }
        i++;
      }, 16.7);
    },

    easeInOutQuad(t, b, c, d) {
      if ((t /= d / 2) < 1) return c / 2 * t * t + b;
      return -c / 2 * (--t * (t - 2) - 1) + b;
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/backToTop/back-to-top.vue